import { MessageCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function FloatingWhatsAppCTA() {
  return <section data-section-id="252346" id="whatsappfloatingbutton" className="fixed right-6 bottom-6 z-50 flex flex-col items-end pointer-events-none bg-background text-foreground">
      <div className="pointer-events-auto relative flex items-center justify-center">
        {}
        <span className="absolute inline-flex h-full w-full animate-ping rounded-lg bg-primary opacity-20 duration-1000"></span>
        
        {}
        <Link to="https://wa.me/6588990728" newTab className="group relative flex h-14 items-center justify-center rounded-lg bg-primary px-4 text-primary-foreground shadow-lg transition-all duration-300 hover:scale-105 hover:shadow-xl" aria-label="Chat with Send It Fit on WhatsApp">
          <MessageCircle className="size-6 shrink-0" />
          <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-default font-semibold tracking-wide opacity-0 transition-all duration-300 ease-in-out group-hover:ml-3 group-hover:max-w-[250px] group-hover:opacity-100">
            Let's Get Moving
          </span>
        </Link>
      </div>
    </section>;
}